import { render, staticRenderFns } from "./ArchiveList.vue?vue&type=template&id=2984cad6&scoped=true"
import script from "./ArchiveList.vue?vue&type=script&lang=js"
export * from "./ArchiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2984cad6",
  null
  
)

export default component.exports